module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "access-form"
  }, [_vm._t("default"), _vm._v(" "), _c('data-form', {
    attrs: {
      "entity": _vm.formModel,
      "fields": _vm.fields,
      "hide-buttons": "",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.onChange
    }
  }, [(!_vm.buttons) ? [(!_vm.unlocked) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !!_vm.access.pending_access_id ||  !!_vm.access.hasOwnProperty('attempts')
    },
    on: {
      "click": function($event) {
        _vm.unlocked = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.edit')))]) : [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAccess
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save-scheduled')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.sendAccess
    }
  }, [_vm._v(_vm._s(_vm.$t('button.send')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.unlocked = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))])], _vm._v(" "), (_vm.access.pending_access_id) ? _c('span', [_vm._v(_vm._s(_vm.$t('label.has-pending-access')))]) : _vm._e()] : _vm._l((_vm.buttons), function(b) {
    return _c('el-button', {
      on: {
        "click": function () { return b.action(_vm.formModel); }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.' + b.title)))])
  })], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59773794!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/access/AccessForm.vue
// module id = 1159
// module chunks = 2